
const photos = {
    state: {
        photo_api_err_status: false,
        photo_api_pending_status: true,
        photos: [
            {
                id: 2331,
                text: `Lorem ipsum dolor sit amet consectetur adipisicing elit.Eveniet, sunt omnis! Inventore reiciendis repellat, 
                laboriosam sit culpa aliquid porro aut facere non,
                 blanditiis accusamus numquam ab dolor pariatur, laudantium fugiat`,
                heart: 12,
                photo : '../assets/imgs/p-1.jpg',
                is_heart: false,
                comments: [
                    
                ],
                comment_form: false,
                date : '2/3/2020'
            },
            {
                id: 2332,
                text: "Photo two",
                heart: 4,
                photo : '../assets/imgs/p-2.png',
                is_heart: false,
                comments: [],
                comment_form: false,
                date : '2/3/2020'
            },
            {
                id: 2333,
                text: "Photo three",
                heart: 39,
                is_heart: false,
                photo : '../assets/imgs/p-3.jpg',
                comments: [],
                comment_form: false,
                date : '2/3/2020'
            },
            {
                id: 2334,
                text: "Photo four",
                heart: 20,
                is_heart: false,
                photo : '../assets/imgs/p-4.jpg',
                comments: [],
                comment_form: false,
                date : '2/3/2020'
            },
            {
                id: 2335,
                text: "Photo five",
                heart: 20,
                is_heart: false,
                photo : '../assets/imgs/p-5.jpg',
                comments: [],
                comment_form: false,
                date : '2/3/2020'
            },
            {
                id: 2336,
                text: "Photo six",
                heart: 25,
                is_heart: false,
                photo : '../assets/imgs/p-6.jpg',
                comments: [],
                comment_form: false,
                date : '2/3/2020'
            }
        ],
    },
    getters: {
        getPhotos: state => state.photos,
        getPhotosApiErrStatus: state => state.photo_api_err_status,
        getPhotosApiPendingStatus: state => state.photo_api_pending_status
    },
    actions: {
        initPhotosApi({ state }) {
            state.photo_api_err_status = false;
            state.photo_api_pending_status = false;
            //call api
            // fetch('https://jsonplaceholder.typicode.com/posts')
            //     .then(response => response.json())
            //     .then(json =>commit("INITPHOTOSAPI",json)).catch(
            //         err => {state.photo_api_err_status = true;console.log(err)}
            //     ).finally(
            //         function(){state.photo_api_pending_status = false}
            //     )
        },
        heartPhoto({ commit }, payload) {
            //call api
            commit('HEARTPHOTO', payload)
        },

        photoCommentFormToggle({ commit }, payload) {
            //no need call api
            commit("PHOTOCOMMENTFORMTOGGLE", payload)
        },
        addCommentToPhoto({ commit }, payload) {
            //call api
             console.log(payload)
            commit("ADDCOMMENTOPHOTO", payload)
        }
    },
    mutations: {
        INITPHOTOSAPI(state, payload) {
            state.photos = payload;
        },
        //addheart and unheart
        HEARTPHOTO(state, payload) {
            var photo_index = state.photos.findIndex(photo => photo.id === payload)
            if (!state.photos[photo_index].is_heart) {
                //call  api
                state.photos[photo_index].heart = ++state.photos[photo_index].heart
                state.photos[photo_index].is_heart = true
            } else {
                //unheart
                //call api
                state.photos[photo_index].heart = --state.photos[photo_index].heart
                state.photos[photo_index].is_heart = false
            }
        },
        //add comment
        ADDCOMMENTOPHOTO(state, payload) {
            //call api
            var photo_index = state.photos.findIndex(photo => photo.id === payload.id)
            state.photos[photo_index].comments.push(
                {
                    value: payload.comment_value,
                    data: payload.date
                }
            )
        },
        //show comment form
        PHOTOCOMMENTFORMTOGGLE(state, payload) {
            var photo_index = state.photos.findIndex(photo => photo.id === payload)
            if (!state.photos[photo_index].comment_form) {
                state.photos[photo_index].comment_form = true
            } else {
                state.photos[photo_index].comment_form = false
            }
        }
    }
}

export default photos 